// TeamContext.js
import { createContext, useContext, useState, useEffect } from "react";

const TeamContext = createContext();

export function TeamProvider({ children }) {
  const [selectedTeam, setSelectedTeam] = useState(null);

  // Restore from localStorage
  useEffect(() => {
    const stored = localStorage.getItem("selectedTeam");
    if (stored) {
      setSelectedTeam(JSON.parse(stored));
    }
  }, []);

  const selectTeam = (team) => {
    setSelectedTeam(team);
    localStorage.setItem("selectedTeam", JSON.stringify(team));
  };

  const clearTeam = () => {
    setSelectedTeam(null);
    localStorage.removeItem("selectedTeam");
  };

  return (
    <TeamContext.Provider value={{ selectedTeam, selectTeam, clearTeam }}>
      {children}
    </TeamContext.Provider>
  );
}

export const useTeam = () => useContext(TeamContext);
